import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, NavigationExtras, Router } from '@angular/router';
import { CognitoUser } from 'amazon-cognito-identity-js';
import { BehaviorSubject, Subscription } from 'rxjs';
import { AuthNewService } from '../../../service/auth-new.service';
import { StorageService } from '../../../service/storage.service';
import { fetchAuthSession } from 'aws-amplify/auth';

@Component({
  selector: 'app-user-sign-in',
  templateUrl: './user-sign-in.component.html',
  styleUrls: ['./user-sign-in.component.scss']
})
export class UserSignInComponent implements OnInit, OnDestroy {

  signinForm!: FormGroup;
  codeForm!: FormGroup;
  submitted = false;
  username!: string;
  password!: string;
  code!: string;
  user!: CognitoUser;
  userAuthenticated = false;
  mfaFlag = false;
  userGroup = new BehaviorSubject<string>('');
  hide = true;
  error?: string | null;
  userRole?: string | null;
  MfaUser?: string;
  private currentLoginUser?: Subscription;
  private signInError?: Subscription;
  resendEnabled = false;
  resendTimeout: any;
  extractDays?: number;
  navigationExtras?: NavigationExtras;
  forgotbuttondisabled = false;
  countSignInFailedAttempt = 0;
  functionCall = false;
  lastAttemptedUsername = '';
  registeredmail:string;

  constructor(public formBuilder: FormBuilder, public router: Router, private authservice: AuthNewService,
    private storageService: StorageService,
  private activatedroute:ActivatedRoute) {
    this.resendTimeout = setTimeout(() => {
      this.resendEnabled = true;
    }, 20000);
  }

  ngOnInit(): void {
       this.activatedroute.queryParams.subscribe(params => {
      this.mfaFlag = params['MFA_Required'];
      this.userAuthenticated = false;
    });
    this.resendEnabled = false;
    this.error = '';
    this.signinForm = this.formBuilder.group({
      username: ['', Validators.required],
      password: ['', Validators.required]
    });

    this.codeForm = this.formBuilder.group({
      code: ['', Validators.required]
    });
  }
  get formControls() { return this.signinForm.controls; }
  get formControls1() { return this.codeForm.controls; }

  signInNew() {
    this.functionCall = true;
    this.submitted = true;
    this.userAuthenticated = false;
    this.error = '';
    if (this.signinForm.invalid) {
      return;
    }
    this.username = this.signinForm.value.username;
    this.password = this.signinForm.value.password;

    if (this.username !== this.lastAttemptedUsername) {
      this.countSignInFailedAttempt = 0;
      this.lastAttemptedUsername = this.username;
    }
    this.authservice.signIn(this.username, this.password).then((result: any) => {
      if (result.Status === 'MFA') {
        this.registeredmail=result.nextStep.codeDeliveryDetails.destination
        this.mfaFlag = true;
      } else if (result.Status === 'NEW_PASSWORD') {
        this.router.navigate(['/extra-layout/new-password']);
      } else if (result.Status === 'SUCCESS') {
        const storedData = this.storageService.get('access');
        const daysLeftStr = this.storageService.get('days_left');
        this.extractDays = isNaN(Number(daysLeftStr)) ? 0 : Number(daysLeftStr);
        this.navigationExtras = {
          queryParams: { days_left: this.extractDays }
        };
        if (this.extractDays && (this.extractDays > 0) && (this.extractDays <= 10)) {
          this.router.navigate(['/extra-layout/password-validity'], this.navigationExtras);
        }
        else if (this.extractDays <= 0) {
          this.router.navigate(['/extra-layout/new-password'], { queryParams: { passtype: 'Change' } });
        }
        else if (storedData == 'QA') {
          this.router.navigate(['default-layout/user-details']);
        }
        else { this.router.navigate(['default-layout/previous-analysis']); }

      } else {
        this.submitted = false;
        this.error = 'Username or Password is incorrect';
      }
    });

    this.signInError = this.authservice.signinError.subscribe((error: any) => {
      if (error) {
        this.submitted = false;
        if (error instanceof Error && error.message.includes('User does not exist.')) {
          this.error = 'User does not exist.';
        }
        else if (error instanceof Error && error.message.includes('Unable to login because of security reasons.')) {
          this.error = 'Login blocked for security reasons. Please contact support.';
        }
        else if (error instanceof Error && (error.message.includes('You have crossed the signin attempts') || error.message.includes('User is disabled.'))) {
          this.forgotbuttondisabled = true;
          this.error = 'Your account has been blocked. Please contact support.';
        }
        else if (error instanceof Error && error.message.includes('Password attempts exceeded')) {
          this.forgotbuttondisabled = true;
          this.error = 'Password attempts limit exceeded. Please contact support.';
        }
        else {
          this.error = '';
          if (this.functionCall) {
            this.countSignInFailedAttempt++;
            this.functionCall = false;
          }
          if (this.countSignInFailedAttempt <= 3) {
            this.error = `Username or Password is incorrect.Attempts left ${3 - this.countSignInFailedAttempt}`;
          }
        }
      } else {
        this.error = '';
      }
    });
  }

  confirmationCode() {
    this.code = this.codeForm.value.code;
    this.resendEnabled = false;
    this.authservice.confirmCode(this.code, async (error, newUser) => {
      if (error) {
        console.error(error);
        this.error = 'Incorrect Confirmation Code';
        this.resendEnabled = true;
      }
      else {
        try {
          const session = await fetchAuthSession();
          const accessToken = session.tokens?.accessToken?.toString();
          this.resendEnabled = false;
          if (accessToken) {
            this.userAuthenticated = true;
            this.user = newUser;

            await this.authservice.getMFACurrentUser(); // this sets MfaUser BehaviorSubject
            this.currentLoginUser = this.authservice.MfaUser.subscribe((user) => {
              this.userRole = this.storageService.get('access');

              if (this.userRole === 'QA') {
                this.router.navigate(['default-layout/user-details']);
              } else {
                this.router.navigate(['default-layout/previous-analysis']);
              }
            });
          } else {
            this.error = 'Access token missing. Sign-in may have failed.';
          }
        } catch (sessionError) {
          console.error('Failed to fetch session:', sessionError);
          this.error = 'Session error occurred.';
        }
      }
    });
  }


  clearError() {
    this.error = '';
  }
  resendOTP(): void {
    this.error = null;
    this.signInNew();
    this.resendEnabled = false;
    clearTimeout(this.resendTimeout);
    this.resendTimeout = setTimeout(() => {
      this.resendEnabled = true;
    }, 20000);

  }

  ngOnDestroy() {
    // Unsubscribe from the observable to avoid memory leaks
    clearTimeout(this.resendTimeout);
    if (this.currentLoginUser) {
      this.currentLoginUser.unsubscribe();
    }
    if (this.signInError) {
      this.signInError.unsubscribe();
    }
  }
}
